module.exports = __webpack_public_path__ + "static/media/shapes_15.53bc3f89.svg";